export default {
    timestamp() {
        return Math.round(new Date().getTime() / 1000);
    }
}